import React from 'react';
import Link from 'next/link';

/**
 * Signature de marque « Bright Dental LAB » : monogramme officiel (BDL) à gauche
 * + logotype à droite. Deux tonalités selon le fond (clair / sombre).
 * Le monogramme est extrait du logo réel (public/assets/images/bdl-mark-*.png).
 */
export function BrandMark({
  tone = 'dark',
  className,
  href = '/',
}: {
  tone?: 'dark' | 'light';
  className?: string;
  href?: string | null;
}) {
  const primary = tone === 'light' ? 'text-white' : 'text-ink';
  // tone 'light' = sur fond sombre → monogramme blanc ; sinon monogramme noir.
  const mark = tone === 'light' ? '/assets/images/bdl-mark-dark.png' : '/assets/images/bdl-mark-light.png';

  const content = (
    <span data-component-id="src/components/marketing/BrandMark.tsx:23:4" data-component-path="src/components/marketing/BrandMark.tsx" data-component-line="23" data-component-end-line="38" data-component-file="BrandMark.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`inline-flex items-center gap-3 ${className ?? ''}`}>
      <img data-component-id="src/components/marketing/BrandMark.tsx:24:6" data-component-path="src/components/marketing/BrandMark.tsx" data-component-line="24" data-component-end-line="29" data-component-file="BrandMark.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22src%22%3A%22%5Bvar%3Amark%5D%22%2C%22alt%22%3A%22Bright%20Dental%20Lab%22%2C%22className%22%3A%22h-10%20w-auto%20shrink-0%20object-contain%22%7D"
        src={mark}
        alt="Bright Dental Lab"
        className="h-10 w-auto shrink-0 object-contain"
        draggable={false}
      />
      <span data-component-id="src/components/marketing/BrandMark.tsx:30:6" data-component-path="src/components/marketing/BrandMark.tsx" data-component-line="30" data-component-end-line="37" data-component-file="BrandMark.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22flex%20flex-col%20leading-none%22%7D" className="flex flex-col leading-none">
        <span data-component-id="src/components/marketing/BrandMark.tsx:31:8" data-component-path="src/components/marketing/BrandMark.tsx" data-component-line="31" data-component-end-line="33" data-component-file="BrandMark.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Bright%20Dental%20Lab%22%7D" className={`text-[14px] font-semibold uppercase tracking-[0.15em] ${primary}`}>
          Bright Dental Lab
        </span>
        <span data-component-id="src/components/marketing/BrandMark.tsx:34:8" data-component-path="src/components/marketing/BrandMark.tsx" data-component-line="34" data-component-end-line="36" data-component-file="BrandMark.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22mt-1%20text-%5B9px%5D%20font-medium%20uppercase%20tracking-%5B0.38em%5D%20text-gold-500%22%2C%22textContent%22%3A%22Mastery%20%26%20Harmony%22%7D" className="mt-1 text-[9px] font-medium uppercase tracking-[0.38em] text-gold-500">
          Mastery &amp; Harmony
        </span>
      </span>
    </span>
  );

  if (href === null) return content;

  return (
    <Link data-component-id="src/components/marketing/BrandMark.tsx:44:4" data-component-path="src/components/marketing/BrandMark.tsx" data-component-line="44" data-component-end-line="46" data-component-file="BrandMark.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%2C%22className%22%3A%22inline-flex%20items-center%20transition-opacity%20hover%3Aopacity-80%22%7D" href={href} className="inline-flex items-center transition-opacity hover:opacity-80">
      {content}
    </Link>
  );
}
